import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, Tabs } from 'ionic-angular';
import { Observable } from 'rxjs/Rx';

import { BtLocalService } from '../../app/core/local-data-services/bt-local.service';
import { MeasureContextService } from '../../app/core/measure-context.service';
import { MeasureLocalService } from '../../app/core/local-data-services/measure-local.service';
import { SummaryService } from './summary.service';
import { BT, Measure } from '../../app/models/models';

@Component({
  selector: 'page-summary',
  templateUrl: 'summary.html'
})
export class SummaryPage {

  currentBt: BT;
  bts: BT[];
  measures: Measure[];
  measuresByBt: Map<string, Measure[]> = new Map();
  measuresByBtAndLocation: Map<string, Map<string, Measure[]>> = new Map();
  missingPksByBtAndLocation: Map<string, Map<string, number[]>> = new Map();
  specificMeasuresByBt: Map<string, Measure[]> = new Map();
  tabs: Tabs;

  constructor(private alertCtrl: AlertController,
              private loadingCtrl: LoadingController,
              private measureContextService: MeasureContextService,
              private measureLocalService: MeasureLocalService,
              public summaryService: SummaryService,
              private navCtrl: NavController,) {
    this.currentBt = BtLocalService.getBT();
    this.tabs = navCtrl.parent;
  }

  ionViewWillEnter() {
    this.currentBt = BtLocalService.getBT();
    this.getAndFormatMeasuresData();
  }

  closeBT(): void {
    this.currentBt = null;
    BtLocalService.deleteBT();
    this.measureContextService.reset();
    this.tabs.select(0);
  }

  sendData(): void {
    const loading = this.loadingCtrl.create({
      content: 'Envoi des mesures en cours...'
    });
    loading.present();

    this.summaryService.saveAllMeasures()
      .map(() => {
        this.clearSummary();
        loading.dismiss();
      })
      .catch((error) => {
        loading.dismiss();
        this.showErrorAlert();
        console.error(error);
        return Observable.empty();
      }).subscribe(res => this.summaryService.launchCompute());
  }

  getBtState(btString: string): string {
    let closed: string = 'Clôturé';
    let open: string = 'En cours';

    if (!this.currentBt) {
      return closed;
    }
    return this.currentBt.number + '/' + this.currentBt.indice === btString ? open : closed;
  }

  private clearSummary() {

    this.measures = [];
    this.measuresByBt = new Map();
    this.specificMeasuresByBt = new Map();
    this.measuresByBtAndLocation = new Map();
    this.missingPksByBtAndLocation = new Map();
  }

  private getAndFormatMeasuresData(): void {
    this.measureLocalService.getDistinctBTs()
      .flatMap(
        (bts: BT[]) => {
          this.bts = bts;
          return this.measureLocalService.getAllMeasures()
        })
      .subscribe(
        measures => {
          this.measures = measures;
          this.measuresByBt = this.summaryService.organizeMeasuresByBt(measures);
          this.specificMeasuresByBt = this.summaryService.getSpecificMeasures(this.measuresByBt);
          this.measuresByBtAndLocation = this.summaryService.organizeMeasuresByBtAndLocation(this.measuresByBt);
          this.missingPksByBtAndLocation = this.summaryService.calculateMissingPksByBtAndLocation(this.measuresByBtAndLocation);
        });
  }

  private showErrorAlert() {
    let alert = this.alertCtrl.create({
      subTitle: 'Une erreur s\'est produite',
      message: 'Veuillez vérifier votre connexion et réessayer',
      buttons: ['Fermer']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/summary/summary.ts